import throwError from './throwError';

const throw404 = () => throwError(404, 'ENOENT', 'Not Found');

export default throw404;
